<template>
  <div>
   <div class="card-header"> <a class="no-hover btn-block text-left collapsed" data-toggle="collapse" :href="getID" role="button" aria-expanded="false" :data-target ="getID" :aria-controls=identifier> <p><strong>{{title}}</strong><span style="float:right" class="triangle"></span></p></a></div>
    <hr>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "menuComp",
    props: {
      title: String,
      identifier: String
    },
    computed:{
      getID(){
        return "#"+this.identifier
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/menuComp.vue